import * as Types from '../constants/Types';
import { PAGINATION } from '../constants/Define';

const initialState = {
    isSubmit: false,
    isFetching: false,
    isGetItem: false,
    data: {
        pageSize: PAGINATION.pageSize,
        pageIndex: PAGINATION.pageIndex,
        totalCount: PAGINATION.totalCount,
    },
};

export default (state = initialState, action) => {
    switch (action.type) {
        case Types.ROLE_LIST_ACTION:
            return { ...state, isFetching: true };
        case Types.ROLE_LIST_SUCCESS:
            return { ...state, isFetching: false, data: action.roles, isSubmit: false };   
        case Types.ROLE_LIST_ALL_ACTION:
            return { ...state, isFetching: true };    
        case Types.ROLE_LIST_ALL_SUCCESS:
            return { ...state, isFetchingUpdate: false, allRoles: action.allRoles };
        case Types.ROLE_GET_UPDATE_ACTION:
            return { ...state, isFetchingUpdate: true, isGetItem: true };
        case Types.ROLE_GET_UPDATE_SUCCESS:
            return { ...state, isFetchingUpdate: false, dataUpdate: action.dataUpdate, isGetItem: false, isSubmit: false };
        case Types.ROLE_CREATE_ACTION:
            return { ...state, isFetching: true, isSubmit: true };        
        case Types.ROLE_UPDATE_ACTION:
            return { ...state, isFetching: true, isSubmit: true };
        case Types.ROLE_DELETE_ACTION:
            return { ...state, isFetching: true, isSubmit: true };
        case Types.ROLE_UPDATE_SUCCESS:
            return { ...state, isFetching: false, isSubmit: false };
        case Types.ROLE_FAIL:
            return { ...state, isFetching: false, isSubmit: false, isGetItem: false };

        default:
            return state;
    }
}
